export default {
  sm: {
    container: {
      '--slider-track-width': '26px',
      '--slider-track-height': '16px',
    },
  },
  md: {
    container: {
      '--slider-track-width': '36px',
      '--slider-track-height': '22px',
    },
  },
  lg: {
    container: {
      '--slider-track-width': '52px',
      '--slider-track-height': '32px',
    },
  },
};
